import { z } from "zod";

// Confirm the change (passport-web /email-change/confirm → POST /auth/email-change/confirm).
// token = 32-byte base64url (43 chars), same shape as the verify/reset tokens.
export const changeEmailConfirmRequestSchema = z.object({
  token: z.string().regex(/^[A-Za-z0-9_-]{43}$/, "Invalid confirmation token"),
});
